import { createAction, props } from '@ngrx/store';
import { IOrganization } from '@shared/models';

export enum ActionTypes {
  Load        = '[Organization] Load',
  LoadSuccess = '[Organization] Load Success',
  LoadFail    = '[Organization] Load Fail',
  Clear       = '[Organization] Clear',
  Decline     = '[Organizations] Decline',
  Approve     = '[Organizations] Approve',
  Remove     = '[Organizations] Remove',
  EnableMfa  = '[Organizations] Enable MFA',
  DisableMfa = '[Organizations] Disable MFA',
  EnableMfaTestMode  = '[Organizations] Enable MFA Test Mode',
  DisableMfaTestMode = '[Organizations] Disable MFA Test Mode'
}

export const load = createAction(
  ActionTypes.Load,
  props<{ id: number }>()
);

export const loadSuccess = createAction(
  ActionTypes.LoadSuccess,
  props<{ organization: IOrganization }>()
);

export const loadFail = createAction(
  ActionTypes.LoadFail,
  props<{ error: string }>()
);

export const clear = createAction(
  ActionTypes.Clear
);

export const decline = createAction(
  ActionTypes.Decline,
  props<{ id: number }>()
);

export const approve = createAction(
  ActionTypes.Approve
);

export const remove = createAction(
  ActionTypes.Remove
);

export const enableMfa = createAction(
  ActionTypes.EnableMfa
);

export const disableMfa = createAction(
  ActionTypes.DisableMfa
);

export const enableMfaTestMode = createAction(
  ActionTypes.EnableMfaTestMode
);

export const disableMfaTestMode = createAction(
  ActionTypes.DisableMfaTestMode
);

